import { all, call, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { READINGS } from '../config';
import { getJSON } from '../util';
import _ from 'underscore';

export function* getFavoriteDeck(user) {
    if (!user.favorite_deck_id) {
        return null;
    }

    const decks = yield select(state => state.decks);

    if (!decks || !decks.length) {
        return null;
    }

    return _.find(decks, deck =>
        deck.deck == user.favorite_deck_id
    );
}

export function* getSaved() {
    const params = yield select(state => state['query-params']);
    if (params.report) {
        yield call(fetchSample, params.report);
        return;
    }

    const user = yield select(state => state.user);
    if (!user.logged_in) {
        return;
    }
}

export function* validateFetch() {
    const user = yield select(state => state.user);
    const { cards, positions } = yield select(state => state['tarot-reading']);

    if (cards.length !== positions.length) {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                error: {
                    remaining: positions.length - cards.length,
                },
            },
        });
        return;
    }

    if (!user.logged_in) {
        yield all([
            put({
                type: 'product:update',
                payload: {
                    pending: true,
                },
            }),
            put({
                type: 'route:to',
                payload: 'login',
            }),
            take('user:logged-in'),
        ]);

        const upc = yield select(state => state.product.teeup.code);
        if (upc == 'self-knowledge-tarot-redux') {
            yield call(getJSON, `/api/product/voucher/${upc}`);
        }
    }

    yield call(waitForPendingProduct);

    const submitting = yield select(state => state.product.submitting);
    if (submitting) {
        return;
    }

    yield put({
        type: 'product:update',
        payload: {
            submitting: true,
        },
    });

    const config = yield select(state => state.product.teeup);
    if (config.upsell_upc) {
        yield call(fetch, cards);
        return;
    }

    yield call(checkoutSubmit, cards);
}

export function* getProductPending() {
    let productUpdate = yield take('product:update');
    return productUpdate.payload.pending;
}

export function* waitForPendingProduct() {
    const pending = yield select(state => state.product.pending);
    if (pending) {
        const nextRoute = yield take('route:to');
        if (nextRoute.payload == 'sms') {
            //wait for sms modal close
            let productPending = true;
            while (productPending) {
                productPending = yield call(getProductPending);
            }
        }
    }
}

export function* getSubscription(upc, price) {
    if (
        _.contains(['daily-reflection-tarot-redux', 'forecast-monthly-subscription'], upc)
        ||
        (price.usd && price.usd.billing_type == 'subscription')
    ) {
        return;
    }

    const sub_upc = upc == 'daily-reflection-tarot-redux' ? 'drt-monthly-subscription' : upc;

    const [api, params] = yield all([
        select(state => state.api.host),
        select(state => state.api.params),
    ]);

    const desc = yield call(getJSON, `${api}/product/description/${sub_upc}`, params);

    yield put({
        type: 'product:update',
        payload: {
            subscription: {
                description: desc,
            },
        },
    });
}

export function* checkoutSubmit(cards) {
    const deck = yield select(state => state.deck.code);
    const subject = yield select(state => state['tarot-reading'].subject);
    const upc = yield select(state => state.product.teeup.code);
    const report_slug = yield select(state => state.product.report_slug);
    let submit = READINGS.submit;

    if (/mandala/.test(upc)) {
        const positions = yield select(state => state['tarot-reading'].positions);

        cards = cards.map((card, i) => {
            return {
                card_id: card,
                orientation: positions[i].orientation,
                position: positions[i].position,
            };
        });

        submit = READINGS.submitMandala;
    }

    try {
        const order = yield call(submit, cards, deck, subject, upc, report_slug);
        yield put({
            type: 'location:href',
            payload: order.forwarding_url,
        });
    } catch (e) {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                interps: {
                    error: e,
                },
            },
        });
    }
}

export function* fetchSample(product_result_uuid) {
    let response;
    try {
        response = yield call(READINGS.fetchSampleInterps, product_result_uuid);
    } catch (e) {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                interps: {
                    error: e,
                },
            },
        });
        return;
    }
    const upc = yield select(state => state.product.teeup.code);
    if (response.upc != upc) {
        // Reading is already upgraded
        return;
    }

    yield call(pickCards, response.interpretations.map((interp) => interp.card));

    yield all([
        put({
            type: 'deck:required',
            payload: response.deck_code,
        }),
        put({
            type: 'tarot-reading:update',
            payload: {
                interps: response.interpretations,
                subject: response.question,
                cards: response.interpretations.map((interp) => interp.card),
            },
        }),
        put({
            type: 'route:to',
            payload: 'tarot-reading/self',
        }),
        put({
            type: 'product:update',
            payload: {
                report_slug: product_result_uuid,
            },
        }),
    ]);
}

export function pickCards(card_ids) {
    const cards = document.querySelectorAll('deck-card');
    let card;
    for (let c = 0; c < cards.length; c++) {
        card = cards[c]._tag;

        if (card_ids.indexOf(card.card_id) > -1) {
            card.pick();
        }
    }
}

export function* fetch(cards) {
    const deck = yield select(state => state.deck.code);
    const subject = yield select(state => state['tarot-reading'].subject);
    const upc = yield select(state => state.product.teeup.code);
    let response;
    try {
        response = yield call(READINGS.submitSample, upc, cards, deck, subject);
    } catch (e) {
        yield put({
            type: 'tarot-reading:update',
            payload: {
                interps: {
                    error: e,
                },
            },
        });

        return;
    }

    yield all([
        put({
            type: 'tarot-reading:update',
            payload: {
                interps: response.interpretations,
            },
        }),
        put({
            type: 'route:to',
            payload: 'tarot-reading/self',
        }),
        put({
            type: 'product:update',
            payload: {
                report_slug: response.report_slug,
                submitting: false,
            },
        }),
    ]);
}

export function* init({ payload }) {
    const config = yield call(getJSON, `/api/product/description/${payload.upc}/teeup`);

    config.positions = config.fields[2].positions;

    yield put({
        type: 'member:reset-inactive-deck',
    });

    let res = yield all([
        put({
            type: 'tarot-reading:update',
            payload: {
                positions: config.positions,
                type: payload.type,
            },
        }),
        put({
            type: 'product:update',
            payload: {
                teeup: config,
            },
        }),
        put({
            type: 'price:required',
            payload: { upc: payload.upc },
        }),
        put({ type: 'cordial:init' }),
        put({ type: 'cordial:browse' }),
        take('product:update'),
    ]);

    const price = res ? res[4] : null;

    if (config.upsell_upc) {
        yield call(getSaved, config.positions);
    }

    yield call(getSubscription, payload.upc, price);

    if (payload.upc == 'yes-or-no-tarot-redux') {
        yield all([
            put({
                type: 'deck:spread',
                payload: 10,
            }),
            put({
                type: 'tarot-reading:update',
                payload: {
                    button_text: 'shuffle cards',
                    card: 10,
                    source: 'Pre-Selected',
                    cards: [10],
                },
            }),
        ]);
    }
}

export function* watchOrient() {
    while (true) {
        yield take('tarot-reading:orient');

        const positions = yield select(state => state['tarot-reading'].positions);

        const newPositions = positions.map(position => {
            position.orientation = _.shuffle(['upright', 'right', 'left', 'reverse'])[0];

            return position;
        });

        yield put({
            type: 'tarot-reading:update',
            payload: {
                positions: newPositions,
            },
        });
    }
}

export function* pickedCard({ payload }) {
    const cards = yield select(state => state['tarot-reading'].cards);

    // make sure we don't set the product type unless the user is actually
    // engaging with the reading, in the case of the widget
    if (cards && cards.length === 1) {
        yield put({
            type: 'product:update',
            payload: {
                type: 'Reading',
            },
        });
    }

    yield put({
        type: 'tarot-reading:update',
        payload: {
            error: null,
            cards: _.uniq(cards.concat(payload.card)),
        },
    });
}

export function* setSubject() {
    while (true) {
        const action = yield take('tarot-reading:question');
        const question = action.payload || '';

        yield put({
            type: 'tarot-reading:update',
            payload: {
                subject: question,
            },
        });
    }
}

export function* watchUpsell() {
    while (true) {
        yield take('tarot-reading:upsell');

        let value = 'Tarot Reading';

        const sample_interps = yield select(state => state['tarot-reading'].interps);
        const upc = yield select(state => state.product && state.product.teeup.code);
        const type = yield select(state => state['tarot-reading'].type);

        if (!type) {
            value += ' Module';
        }

        yield all([
            put({
                type: 'tarot-reading:update',
                payload: {
                    interps: null,
                    sample_interps: sample_interps,
                },
            }),
            put({
                type: 'route:to',
                payload: 'celtic-cross',
            }),
            put({
                type: 'promo-tracker:recordInternal',
                payload: [value + ' Upsell', upc],
            }),
        ]);
    }
}

export function* watchFavoriteDeck() {
    while (true) {
        const { payload: user } = yield take('user:update');
        const favorite_deck = yield call(getFavoriteDeck, user);
        const deck = yield select(state => state.deck);

        let deck_code = null;

        if (deck && deck.code && deck.code != 'mandala') {
            if (favorite_deck && favorite_deck.code) {
                deck_code = favorite_deck.code;
            }
        }

        if (deck_code) {
            yield put({
                type: 'deck:required',
                payload: deck_code,
            });
        }
    }
}

export function* resetFetch() {
    while (true) {
        const payload = yield take('tarot-reading:update');

        if (payload && payload.interps) {
            yield put({
                type: 'product:update',
                payload: {
                    submitting: false,
                },
            });
        }
    }
}

export function* shuffleDeck() {
    const spread = yield select(state => state.spread);
    const shuffled = _.shuffle(spread.filter(card => { return card != 'picked'; }));
    const new_spread = Object.keys(spread).map(key => {
        if (spread[key] != 'picked') {
            const rand = Math.floor(Math.random() * shuffled.length);
            spread[key] = shuffled[rand];
            shuffled.splice(rand, 1);
        }

        return spread[key];
    });

    yield put({
        type: 'spread:update',
        payload: new_spread,
    });
}

export function* root() {
    yield all([
        fork(watchOrient),
        fork(setSubject),
        fork(watchUpsell),
        fork(resetFetch),
        fork(watchFavoriteDeck),
        takeEvery('tarot-reading:shuffle-deck', shuffleDeck),
        takeEvery('tarot-reading:init', init),
        takeEvery('tarot-reading:fetch', validateFetch),
        takeEvery('tarot-reading:picked', pickedCard),
    ]);
}
